<template>
  <v-layout row>
    <v-flex xs12>
    <v-toolbar app>
    <v-btn icon @click="back"><v-icon>keyboard_arrow_left</v-icon></v-btn>
    <v-toolbar-title>Detalle de la entrega</v-toolbar-title>
    <v-spacer></v-spacer>
     
  </v-toolbar>
   
        <v-list two-line class="list-view">
          <template>
            <v-list-tile class="list-view-item"
              avatar
              ripple
            >
              <v-list-tile-content>
                <v-list-tile-title>Ali Connors</v-list-tile-title>
                <v-list-tile-sub-title class="text--primary">Brunch this weekend?</v-list-tile-sub-title>
                <v-list-tile-sub-title class="mb5">I'll be in your neighborhood doing errands this weekend. Do you want to hang out ?</v-list-tile-sub-title>
                <span class="list-view-item-date">15 min</span>
                <!-- <v-alert :value="true" color="error" class="note">
                  This is an error alert with no icon.
                </v-alert> -->
                <div class="list-view-item-toolbar">
                  <v-btn color="success" small >Ver Mapa</v-btn>
                  <v-btn color="info" small >Escanear Paquetes</v-btn>
                </div>
                <v-select
                  :items="items"
                  label="Recibido por"
                  single-line
                  @change="selected"
                ></v-select>
                
                <h3 class="title-1">Lista de Paquetes</h3>
                <v-list class="list-inside">
                  
                  <template>
                    <v-list-tile>
                      <v-list-tile-action>
                        <v-checkbox v-model="sound"></v-checkbox>
                      </v-list-tile-action>
                      <v-list-tile-content>
                        <v-list-tile-sub-title class="text--primary">Brunch this weekend?</v-list-tile-sub-title>
                      </v-list-tile-content>
                    </v-list-tile>
                    
                  </template>
                  <template>
                    <v-list-tile>
                      <v-list-tile-action>
                        <v-checkbox v-model="sound"></v-checkbox>
                      </v-list-tile-action>
                      <v-list-tile-content>
                        <v-list-tile-sub-title class="text--primary">Brunch this weekend?</v-list-tile-sub-title>
                       
                      </v-list-tile-content>
                    </v-list-tile>
                    
                  </template>
                </v-list>
                <v-btn block color="warning" :to="'/PackageSignature/'+selectOwner" dark>Firmar</v-btn>
              </v-list-tile-content>
            </v-list-tile>
          </template>
        </v-list>
        
        </v-flex>
  </v-layout>
</template>

<script>
export default {
  mounted () {

  },
  data () {
    return {
      clipped: false,
      selectOwner: false,
      sound: true,
      option: {
        penColor: 'rgb(0, 0, 0)',
        backgroundColor: 'rgb(255,255,255)'
      },
      items: [
        {text: 'Propietario', owner: true},
        {text: 'Otra persona', owner: false}
      ]
    }
  },
  computed: {

  },
  props: ['id'],
  name: 'App',
  methods: {
    back: function () {
      this.$router.go(-1)
    },
    selected: function (selected) {
      this.selectOwner = selected.owner
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
